import { components } from 'cng-web-lib'
import ClearableCngSelectFieldBase from './ClearableCngSelectField'
import withMandatoryHighlight from './withMandatoryHighlight'

const { form: { field: { CngTextField, CngDateField, CngDateTimeField } } } = components

export const CngTextFieldMandatory = withMandatoryHighlight(CngTextField)
export const CngDateFieldMandatory = withMandatoryHighlight(CngDateField)
export const CngDateTimeFieldMandatory = withMandatoryHighlight(CngDateTimeField)
export const CngSelectFieldMandatory = withMandatoryHighlight(ClearableCngSelectFieldBase)
